
import { db } from '@/main';

export default class Batch {
    constructor() {
        this.batch = db.batch();
        this.count = 0;
        this.commits = [];
        this.limit = 490;
    }

    reset() {
        this.batch = db.batch();
        this.count = 0;
    }

    commit() {
        this.queue(true);
        return Promise.all(this.commits);
    }

    queue(force = false) {
        if (!force) this.count++;
        if (this.count >= this.limit || (force && this.count > 0)) { // available limit is 500
            this.commits.push(this.batch.commit());
            this.reset();
        }
    }

    set(ref, data) {
        this.batch.set(ref, data);
        this.queue();
    }

    update(ref, data) {
        this.batch.update(ref, data);
        this.queue();
    }

    delete(ref) {
        this.batch.delete(ref);
        this.queue();
    }
}


// WEBPACK FOOTER //
// ./src/lib/batch.js